package org.catharsis.spendtel.core.auth

class GoogleSignInCancelledException : Exception("cancelled")

fun isGoogleSignInCancelled(throwable: Throwable?): Boolean {
    if (throwable is GoogleSignInCancelledException) return true
    val message = throwable?.message.orEmpty()
    return message.contains("cancel", ignoreCase = true) ||
        message.contains("popup-closed", ignoreCase = true)
}
